import React from "react";
import PrintLayout from "./PrintLayout";

export default function LoanPrint({ data }) {
  const user = data.userId || {};

  return (
    <PrintLayout>
      <h4>Customer Details</h4>
      <p><b>Name:</b> {user.name}</p>
      <p><b>Account Number:</b> {user.accountNumber}</p>

      <h4 className="mt-3">Loan Details</h4>
      <p><b>Loan Number:</b> {data.loanAccountNumber}</p>
      <p><b>Amount:</b> ₹ {data.principalAmount}</p>
      <p><b>Interest Rate:</b> {data.interestRate}%</p>
      <p><b>Tenure:</b> {data.tenureMonths} months</p>
      <p><b>Start Date:</b> {new Date(data.startDate).toLocaleDateString()}</p>
      <p><b>Status:</b> {data.status}</p>
    </PrintLayout>
  );
}
